import { useEffect } from "react";

const TEST_DOMAIN = "hisselab.rasyonet.com";
// equityrt.com prod'da (port 80) indexlenebilir olmali; ama preprod'da
// :8080 uzerinden test icin kullanildiginda noindex kalmali. hostname port
// bilgisini icermedigi icin burada host (port dahil) karsilastiriliyor.
const TEST_HOST_WITH_PORT = "hisselab.equityrt.com:8080";

function injectMetaTag(name, content) {
  if (document.querySelector(`meta[name="${name}"]`)) return;
  const meta = document.createElement("meta");
  meta.setAttribute("name", name);
  meta.setAttribute("content", content);
  document.head.appendChild(meta);
}

function isTestDomain() {
  const { hostname, host } = window.location;
  return hostname === TEST_DOMAIN || host === TEST_HOST_WITH_PORT;
}

export function useNoIndexForTestDomain() {
  useEffect(() => {
    if (!isTestDomain()) return;
    injectMetaTag("robots", "noindex, nofollow");
    injectMetaTag("googlebot", "noindex, nofollow");
  }, []);
}
